import React, {useEffect, useCallback} from 'react';
import {useSelector, useDispatch} from 'react-redux';

import MyBookingsUI from '../../../../stories/components/hotels/HomePage/MyBookingsUI/MyBookingsUI';


import {
    MY_TRIPS_DETAILS,
  
    updateActiveTab,
  
    myTripsLoaderSelector,
    myTripsHeadersSelector,
    myTripsActiveTabSelector,
    myTripsBookingDataSelector,
  
    fetchMyTripsData,
  } from '@ibibo/myaccount-reducer';


const MyBookings = () => {
  const dispatch = useDispatch();

  const fetchMyTripsDataCaller = useCallback(() => {
    return dispatch(fetchMyTripsData());
  }, [dispatch]);

  useEffect(() => {
    fetchMyTripsDataCaller();
  }, []);

  const myTripsHeaders = useSelector(myTripsHeadersSelector);
  const activeTab = useSelector(myTripsActiveTabSelector);
  const loading = useSelector(myTripsLoaderSelector);
  const bookingDetails = useSelector(myTripsBookingDataSelector);

  const updateActiveTabFnc = (tabKey) => {
    dispatch(updateActiveTab(tabKey));
  }

  const navigateToMyTripsDetails = id => {
    window.open(`${MY_TRIPS_DETAILS}${id}/?search_id=${id}`, '_blank');
  }

  return(
    <div>
      {(!loading && bookingDetails.length && <MyBookingsUI bookingDetails={bookingDetails} activeTab={activeTab} headers={myTripsHeaders}  updateActiveTab={updateActiveTabFnc} navigateToMyTripsDetails={navigateToMyTripsDetails}/> ) || null}
    </div>
  );
}

export default MyBookings;